import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';

export const projectService = {
  getAll,
  createOrUpdate,
  deleteProject
};
const requestOptions = {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  }
};

function getAll(pageNumber) {
  let url = `${
    process.env.REACT_APP_API_URL}/api/projects/?page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(url, requestOptions)
    .then(responseHandleService.handleResponse)
    .catch(error => console.log(error));
}
function createOrUpdate(newProject) {
  const requestOptions = {
    method: newProject.id ? 'PUT' : 'POST',
    headers: {
      Accept: 'application/json'
    },
    body: createBodyRequest(newProject)
  };

  let authentication = new AuthenticationService();

  console.log(authentication.loggedIn());

  if (authentication.loggedIn()) {
    requestOptions.headers['Authorization'] =authentication.getToken();
  }

  const url = `${process.env.REACT_APP_API_URL}/api/projects${
    newProject.id ? `/${newProject.id}` : ''
  }`;

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}
function createBodyRequest(project) {
  let formData = new FormData();

  formData.append('project[title]', project.title);
  formData.append('project[date]', project.date);
  formData.append('project[description]', project.description);
  const document = project.document;

  if (document) {
    if (document.url) {
      formData.append(`project[document]`, document.url);
    } else {
      formData.append(`project[document]`, document, document.name);
    }
  }

  return formData;
}
function deleteProject(projectId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =this.authentication.getToken();
  }
  let url = `${process.env.REACT_APP_API_URL}/api/projects/${projectId}`;

  return axios.delete(url, requestOptionsDelete);
}
